import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.add-directory', {
        url: '/add-directory/:directoryType',
        views: {
            '@company.directory-integration': 'companyDirectoryIntegrationAddDirectory'
        },
        resolve: {
            directoryType,
        },

    });
}

/** @ngInject */
function directoryType($stateParams) {
    return $stateParams.directoryType;
}




// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/add/add-directory.state.js